var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sortBy === _vm.column)?_c('i',{class:("fa fa-sort-" + _vm.iconType + "-" + _vm.sortByDirTxt)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }